import { render, staticRenderFns } from "./amazon.vue?vue&type=template&id=08c7f8d8"
import script from "./amazon.vue?vue&type=script&lang=js"
export * from "./amazon.vue?vue&type=script&lang=js"
import style0 from "./amazon.vue?vue&type=style&index=0&id=08c7f8d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports